import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Bestselling Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Working with this publishing company was a game-changer for my writing career. Their team handled everything from editing to marketing with exceptional professionalism.',
    rating: 5,
    bookTitle: 'The Journey Within'
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Business Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'The level of expertise and attention to detail exceeded all my expectations. From manuscript to bestseller, they guided me every step of the way.',
    rating: 5,
    bookTitle: 'Scaling Success'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Fiction Writer',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'I couldn\'t have asked for a better publishing partner. Their creative team brought my vision to life with stunning cover designs and professional formatting.',
    rating: 5,
    bookTitle: 'Whispers in Time'
  },
  {
    id: 4,
    name: 'James Anderson',
    role: 'Non-Fiction Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Outstanding service from start to finish. The marketing support helped my book reach audiences I never thought possible. Highly recommended!',
    rating: 5,
    bookTitle: 'Leadership Principles'
  },
  {
    id: 5,
    name: 'Jennifer Williams',
    role: 'Romance Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'The editorial team understood my voice perfectly and helped me craft a story that resonated with readers. My book hit the bestseller list within weeks!',
    rating: 5,
    bookTitle: 'Hearts Entwined'
  },
  {
    id: 6,
    name: 'David Thompson',
    role: 'Self-Help Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Professional, responsive, and incredibly knowledgeable. They turned my manuscript into a polished book that has changed thousands of lives.',
    rating: 5,
    bookTitle: 'Mindful Living'
  },
  {
    id: 7,
    name: 'Amanda Foster',
    role: 'Young Adult Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They believed in my story when others didn\'t. The cover design they created perfectly captures the essence of my book. Forever grateful!',
    rating: 5,
    bookTitle: 'Starlight Academy'
  },
  {
    id: 8,
    name: 'Robert Martinez',
    role: 'Historical Fiction Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Their research team helped me ensure historical accuracy while maintaining an engaging narrative. The result was a critically acclaimed novel.',
    rating: 5,
    bookTitle: 'Echoes of the Past'
  },
  {
    id: 9,
    name: 'Lisa Chang',
    role: 'Cookbook Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'The photography and layout design for my cookbook exceeded my wildest dreams. Every page is a work of art that makes people want to cook!',
    rating: 5,
    bookTitle: 'Flavors of Home'
  },
  {
    id: 10,
    name: 'Thomas Wright',
    role: 'Thriller Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They helped me build suspense in all the right places. Their editorial feedback was invaluable in creating page-turning tension throughout my novel.',
    rating: 5,
    bookTitle: 'The Last Witness'
  },
  {
    id: 11,
    name: 'Patricia Brooks',
    role: 'Children\'s Book Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Working with their illustration team was magical. They brought my characters to life in ways that delight children and parents alike.',
    rating: 5,
    bookTitle: 'Adventures in Dreamland'
  },
  {
    id: 12,
    name: 'Kevin O\'Brien',
    role: 'Science Fiction Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They understood the sci-fi genre perfectly and helped me world-build in a way that was both imaginative and believable. Amazing experience!',
    rating: 5,
    bookTitle: 'Beyond the Nebula'
  },
  {
    id: 13,
    name: 'Maria Gonzalez',
    role: 'Memoir Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They handled my personal story with such care and sensitivity. The editing process helped me find my authentic voice and share my truth.',
    rating: 5,
    bookTitle: 'A Life Reimagined'
  },
  {
    id: 14,
    name: 'Daniel Park',
    role: 'Technology Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Their team made complex technical concepts accessible without dumbing them down. The book has become a go-to resource in the tech community.',
    rating: 5,
    bookTitle: 'The Future of AI'
  },
  {
    id: 15,
    name: 'Rebecca Turner',
    role: 'Poetry Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They understood the delicate nature of poetry and helped me create a beautiful collection. The typography and layout are simply stunning.',
    rating: 5,
    bookTitle: 'Verses of the Soul'
  },
  {
    id: 16,
    name: 'Christopher Lee',
    role: 'Fantasy Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'From world-building to character development, they helped me create an immersive fantasy world. The series is now optioned for TV!',
    rating: 5,
    bookTitle: 'Realm of Shadows'
  },
  {
    id: 17,
    name: 'Nicole Adams',
    role: 'Travel Writer',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They captured the essence of my travel experiences beautifully. The photo integration and design make readers feel like they\'re on the journey with me.',
    rating: 5,
    bookTitle: 'Wanderlust Chronicles'
  },
  {
    id: 18,
    name: 'Brandon Scott',
    role: 'Mystery Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'Their editorial team helped me plant clues and red herrings perfectly. Readers love the twists, and the book has won multiple awards!',
    rating: 5,
    bookTitle: 'The Detective\'s Last Case'
  },
  {
    id: 19,
    name: 'Sophia Anderson',
    role: 'Health & Wellness Author',
    image: 'https://images.unsplash.com/photo-1722371131066-e37037ecf109?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'They helped me translate complex medical concepts into accessible advice. My book is now recommended by doctors and wellness professionals!',
    rating: 5,
    bookTitle: 'Healing From Within'
  },
  {
    id: 20,
    name: 'Marcus Johnson',
    role: 'Sports Biography Author',
    image: 'https://images.unsplash.com/photo-1732166946438-90d000cd032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400',
    text: 'The team captured the intensity and emotion of my athletic journey perfectly. The book has inspired countless young athletes to pursue their dreams.',
    rating: 5,
    bookTitle: 'Against All Odds'
  }
];

const Testimonials = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const testimonialsPerPage = 4;
  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
    }, 6000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, totalPages]);

  const goToNext = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
    setIsAutoPlaying(false);
  };

  const goToPrev = () => {
    setCurrentPage((prevPage) => (prevPage - 1 + totalPages) % totalPages);
    setIsAutoPlaying(false);
  };

  const goToPage = (page) => {
    setCurrentPage(page);
    setIsAutoPlaying(false);
  };

  const currentTestimonials = testimonials.slice(
    currentPage * testimonialsPerPage,
    (currentPage + 1) * testimonialsPerPage
  );

  return (
    <section className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 border-2 border-amber-700 rounded-full mb-6">
            <span className="text-amber-700 text-sm font-semibold tracking-wider">TESTIMONIALS</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            What Our <span className="text-amber-700">Authors Say</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hear from authors who have successfully published with us.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {currentTestimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              className="bg-white rounded-2xl p-6 shadow-2xl hover:shadow-xl transition-all duration-300"
            >
              <div className="flex flex-col h-full">
                {/* Author Info */}
                <div className="flex flex-col items-center text-center gap-2 mb-4">
                  <div>
                    <h4 className="text-lg font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-amber-700 font-semibold text-sm">{testimonial.role}</p>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-3 justify-center">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-amber-700 fill-amber-700" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 text-sm leading-relaxed italic flex-1 text-center">
                  "{testimonial.text}"
                </p>
              </div>
            </Card>
          ))}
        </div>

        {/* Navigation Controls */}
        <div className="flex items-center justify-center gap-6">
          <Button
            onClick={goToPrev}
            variant="outline"
            size="icon"
            className="w-12 h-12 rounded-full border-2 border-amber-700 text-amber-700 hover:bg-amber-700 hover:text-white transition-all"
          >
            <ChevronLeft className="w-6 h-6" />
          </Button>

          {/* Page Indicators */}
          <div className="flex gap-2">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => goToPage(index)}
                className={`h-3 rounded-full transition-all ${
                  index === currentPage
                    ? 'bg-amber-700 w-8'
                    : 'bg-gray-300 w-3 hover:bg-gray-400'
                }`}
                aria-label={`Go to page ${index + 1}`}
              />
            ))}
          </div>

          <Button
            onClick={goToNext}
            variant="outline"
            size="icon"
            className="w-12 h-12 rounded-full border-2 border-amber-700 text-amber-700 hover:bg-amber-700 hover:text-white transition-all"
          >
            <ChevronRight className="w-6 h-6" />
          </Button>
        </div>

        {/* Page Counter */}
        <div className="text-center mt-6">
          <p className="text-gray-600">
            Showing {currentPage * testimonialsPerPage + 1}-{Math.min((currentPage + 1) * testimonialsPerPage, testimonials.length)} of {testimonials.length} testimonials
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;